import React from "react";

const BrandLogo = ({ size = 120 }) => {
  const scale = size / 160;
  return (
    <div style={{
      display: "inline-flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 4,
      userSelect: "none",
    }}>
      <div style={{
        width: size,
        height: size * 0.7,
        background: "linear-gradient(135deg, #1a56db 0%, #0f3fa8 100%)",
        borderRadius: size * 0.14,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 4px 20px rgba(26,86,219,0.35)",
        position: "relative",
        overflow: "hidden",
      }}>
        {/* Shine effect */}
        <div style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "45%",
          background: "rgba(255,255,255,0.1)",
          borderRadius: `${size * 0.14}px ${size * 0.14}px 60% 60%`,
        }}/>
        <span style={{
          fontSize: size * 0.32,
          lineHeight: 1,
          filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.3))",
        }}>💵</span>
      </div>
      <div style={{
        display: "flex",
        alignItems: "baseline",
        gap: 2,
      }}>
        <span style={{
          fontSize: size * 0.22,
          fontWeight: 900,
          color: "#1a56db",
          fontFamily: "'Nunito', sans-serif",
          letterSpacing: -0.5,
          lineHeight: 1,
        }}>Win</span>
        <span style={{
          fontSize: size * 0.22,
          fontWeight: 900,
          color: "#f59e0b",
          fontFamily: "'Nunito', sans-serif",
          letterSpacing: -0.5,
          lineHeight: 1,
        }}>Big</span>
      </div>
    </div>
  );
};

export default BrandLogo;
